    //重定向下载地址
    var get_href_url = location.href;
    var Old_website = 'https://www.anybuds.com/';
    var New_website = 'https://service-survey.vip/';
    var requestParams = '';
    var Old_url = '';
    // https://www.anybuds.com/warranty
    // https://service-survey.vip/buds
    // if (get_href_url.indexOf('?') !== -1) {
    //   requestParams = get_href_url.substr(get_href_url.indexOf('?') + 1); //截取?后面的内容作为字符串
    //   let num = get_href_url.indexOf("?")
    //   Old_url = get_href_url.substring(0,num)
    // }else{
    //   Old_url = get_href_url
    // }
    // console.log(requestParams);

    // console.log(Old_url);

    //产品说明书上的二维码重定向下载地址
    // if(Old_url ==  Old_website + 'download_app.html'){
    //   //耳机下载地址
    //   post_fun('download_app.html')
    // }else if(Old_url == Old_website + 'download_health.html'){
    //   //手表下载地址
    //   post_fun('download_health.html')
    // }else if(Old_url == Old_website + 'warranty'){
    //   //表单调查问卷
    //   post_fun('warranty')
    // }else{
    //   console.log(Old_url, '无');
    // }

    // function post_fun(url){
    //   if(requestParams){
    //     location.href = New_website + url + '?' + requestParams
    //   }else{
    //     location.href = New_website + url
    //   }
    // }

    // 为了处理旧官网的页地址重定向到新地址
    //截止网址后面的路由地址
    var pathname = window.location.pathname;
    if(pathname){
      //截止网址后面的第一个路由地址
      var router = pathname.split('/')[1];
      if(router == 'warranty'){
        var new_web_url = New_website.substring(0, New_website.length - 1); //原因是上面定义的地址后面已经带了/,截取的路由也带了/，拼接就出现了两个，导致地址错误
        location.href = new_web_url + '/buds'
        // location.href = new_web_url + pathname
      }
    }
    
